import { useSelector } from 'react-redux'
import sound from '../../assets/sounds/sound5.mp3'
import { selectSoundEnabled } from '../../store/slices/settingsSlice'

const audioCache: Record<string, HTMLAudioElement> = {}

export const usePlaySound = () => {
  const soundEnabled = useSelector(selectSoundEnabled)
  type VolumeLevel = 0.1 | 0.2 | 0.3 | 0.4 | 0.5 | 0.6 | 0.7 | 0.8 | 0.9 | 1.0

  const playSound = (soundFile: string = sound, volume: VolumeLevel = 1.0) => {
    if (!soundEnabled) return

    if (!audioCache[soundFile]) {
      audioCache[soundFile] = new Audio(soundFile)
    }

    const audio = audioCache[soundFile]
    audio.volume = volume
    audio.currentTime = 0
    audio.play()
  }

  return { playSound }
}